import { useAuth } from "@dl/web-core-js/auth";
import { useMemo } from "react";
import { ProductionOrderNoteClient, type ProductionOrderNoteDTO } from "../../../api/production";
import { NotesPanel, type NoteStore } from "../../../components/NotesPanel";

/** The order's notes, with author and time (0055). */
export function NotesTab({ orderId, editable }: { orderId: number; editable: boolean }) {
  const { http } = useAuth();
  const store = useMemo((): NoteStore<ProductionOrderNoteDTO> => {
    const client = new ProductionOrderNoteClient(http);
    return {
      list: () => client.ofOrder(orderId),
      create: (body) => client.create({ id: 0, production_order_id: orderId, body }),
      update: (note) => client.update(note),
      remove: (id) => client.remove(id),
    };
  }, [http, orderId]);
  return <NotesPanel queryKey={["production", "production-order", orderId, "notes"]} store={store} editable={editable} />;
}
